
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Er kann recht gross sein, und zwar bei allen Verfahren. Bei mittlerer oder
schwerer Migräne beispielsweise hilft die Kombination von Sumatriptan und
Naproxen etwa 28 von 100 Personen, damit sie innerhalb von zwei Stunden
schmerzfrei werden. Mit Placebo haben immerhin 8 von 100 Personen nach zwei
Stunden keine Kopfschmerzen mehr. In einer kleinen Pilotstudie, bei der die
Patienten sogar wussten, dass sie Placebo erhielten, erzielte das
Scheinmedikament immerhin etwa 60 Prozent der Wirkung eines Triptans. Als
Forscher ein Triptan absichtlich als Placebo beschrifteten und das Placebo
umgekehrt die Aufschrift des Triptans trug, wirkte beides gleich gut.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;